// Swiper (~179 KiB min / ~55 KiB gzip) nicht mehr statisch ins Haupt-Bundle
// ziehen. Custom Elements (swiper-container/-slide) upgraden automatisch, sobald
// register() die Definition nachträglich einträgt — server-gerendertes
// swiper-Markup funktioniert also auch bei verzögertem Laden weiter.

let swiperReady = null;

export function ensureSwiper() {
    if (!swiperReady) {
        swiperReady = import("swiper/element/bundle").then(({ register }) => register());
    }
    return swiperReady;
}

// Beim Boot nur laden, wenn die Seite überhaupt Swiper-Elemente enthält
// (Homepage z. B. hat keine → 0 Byte Swiper).
export function ensureSwiperIfPresent() {
    if (document.querySelector("swiper-container, swiper-slide")) return ensureSwiper();
    return Promise.resolve();
}
